module.exports = __webpack_public_path__ + "media/images/it/logo-powered-by-altroconsumo-14971793efd7357f2b008c8325abe235.png";